
import { Component, Prop, Vue } from 'vue-property-decorator'
import { OrderListDto } from '@/api/order'
import { downloadUrl } from '@/utils/util'
import { Getter } from "vuex-class";
import HandleFlowDialog from "@/views/orderManage/template/HandleFlowDialog.vue";
import moment from "moment";
import { toNumber } from "lodash";

@Component({
  name: 'OrderReturnItem',
  components: {
      HandleFlowDialog,
  }
})
export default class OrderReturnItem extends Vue {
  @Getter companyId!: string
  @Prop() orderList: OrderListDto
  @Prop() flag: string
  @Prop() showSelect: boolean
  moment = moment
  currRouteId = ''
  returnOrderId = ''
  downloadUrl = downloadUrl
  $refs!: {
    handleFlowDialog: HandleFlowDialog
  }
  // 查看退单详情
  toDetail (orderInfo) {
      if(this.flag == 'purchaseOrderList') {
        if(!this.$isAction("purchaseOrderReturnDetail")){
          this.$toast('暂无此操作权限，请联系管理员')
          return false
        }
        this.$router.push({
          path: '/purchaseOrderReturnDetail',
          query: {
            returnOrderId: orderInfo.returnOrderId,
            currRouteId: orderInfo.currRouteId,
          }
        })
      } else {
        if(!this.$isAction("orderReturnDetail")){
          this.$toast('暂无此操作权限，请联系管理员')
          return false
        }
        this.$router.push({
          path: '/orderReturnDetail',
          query: {
            returnOrderId: orderInfo.returnOrderId,
            currRouteId: orderInfo.currRouteId,
          }
        })
      }
  }
  // 查看日志
  // 分为退单和订单，订单isReturn 0 退单：isReturn 1
  toLog(orderInfo) {
    if(this.$route.path.includes('salesOrderList')){ //当为销售单页面 退货单
      // if(!this.$action(`toSaleLog`)){
      //   return false
      // }
    }
    if(this.$route.path.includes('purchaseOrderList')){ //当为采购单页面 退货单
      // if(!this.$action(`toLog`)){
      //   return false
      // }
    }
    if(this.$route.path.includes('searchOrder')&&this.$route.query.topType==='1'){ // 销售单搜索页面 退货单
      // if(!this.$isAction(`toSaleLog`)){
      //   this.$toast('暂无此操作权限，请联系管理员')
      //   return false
      // }
    }
    if(this.$route.path.includes('searchOrder')&&this.$route.query.topType==='2'){ // 采购单搜索页面 退货单
      // if(!this.$isAction(`toLog`)){
      //   this.$toast('暂无此操作权限，请联系管理员')
      //   return false
      // }
    }
      this.$router.push({
          path: '/log',
          query: {
              currRouteId: orderInfo.currRouteId,
              orderId: orderInfo.returnOrderId,
              isReturn: '1'
          }
      })
  }


 /**
 * @description: 退款确认
 * @param {*操作类型：8：退款确认} operateType
 * @param {*操作对象} obj
 * @return {*}
 */
  handleCollection (operateType, obj) {
   // if(!this.$action(this.$route.path.includes('orderDetail')?'returnSaleOrderStatus':'updateReturnSaleOrderStatus8')){
   //   return false
   // }
   if(this.$route.path.includes('salesOrderList')){ //当为销售单页面时确认退款
    //  if(!this.$action(`updateReturnSaleOrderStatus8`)){
    //    return false
    //  }
   }
   if(this.$route.path.includes('searchOrder')&&this.$route.query.topType==='2'){ // 销售单搜索页面确认退款
    //  if(!this.$isAction(`updateReturnSaleOrderStatus8`)){
    //    this.$toast('暂无此操作权限，请联系管理员')
    //    return false
    //  }
   }
    this.currRouteId = obj.currRouteId,
    this.returnOrderId = obj.returnOrderId
    let title
    let message
    let isRequired // 备注是否必填
    let isNumberInput // 确认退款改为number输入框判断是否显示number输入框
    switch (operateType) {
      case 4:
        title = '确认收款'
        message = '是否确认订单收款完成？'
        isRequired = false
        isNumberInput = false
        break;
      case 8:
        title = '确认退款'
        message = '是否确认订单退款完成？'
        isRequired = false
        isNumberInput = true
        break;
    }
    (this.$refs.handleFlowDialog as any).show({title, message, operateType, isRequired, isNumberInput})
  }

  handleFlowConfirm({remark, operateType}) {
        // 成功提示
        let tips
        switch (operateType) {
            case 4:
                tips = '确认收款完成'
                break;
            case 8:
                tips = '确认退款完成'
                break;
        }
        // 处理获取请求参数
        let query = this.$route.query
        if (operateType === 8 ) {
          console.log(operateType)
          let params = {
              companyId: this.companyId,
              currRouteId: this.currRouteId,
              orderId: this.returnOrderId,
              orderType: 2, // 2为退货单
              money: toNumber(remark)
          }
          this.$emit('updateReturnOrderStatus', params, tips, operateType)
        } else if (operateType === 4) {
          let orderIdList = [
              {
                  currRouteId: this.currRouteId,
                  returnOrderId: this.returnOrderId
              }
          ]
          let params = {
              companyId: this.companyId,
              operateType,
              orderType: 2, // 2为退货单
              returnOrderIdList: orderIdList,
              orderRemark: remark
          };
          this.$emit('updateReturnOrderStatus', params, tips, operateType)
        }
    }

  /**
 * @description: 操作方法
 * @param {*操作类型：1：退单审核2：退单收货3：退款审核6：作废7：删除8：订单退款} operateType
 * @param {*操作对象} obj
 * @return {*}
 */
  handleOperation (operateType, obj) {
    // if (!this.$action(`updateSaleOrderStatus${operateType}`)) {
    //   return false
    // }
    if(this.$route.path.includes('salesOrderList')){ //当为销售单页面时权限控制
      if(!this.$action(`updateReturnSaleOrderStatus${operateType}`)){
        return false
      }
    }
    if(this.$route.path.includes('purchaseOrderList')){ //当为采购单页面时权限控制
      if(!this.$action(`updateReturnOrderStatus${operateType}`)){
        return false
      }
    }
    if(this.$route.path.includes('searchOrder')&&this.$route.query.topType==='1'){ //当为搜索销售单页面时权限控制
      console.log('updateReturnSaleOrderStatus'+operateType)
      if(!this.$isAction(`updateReturnSaleOrderStatus${operateType}`)){
        this.$toast('暂无此操作权限，请联系管理员')
        return false
      }
    }
    if(this.$route.path.includes('searchOrder')&&this.$route.query.topType==='2'){ //当为搜索销售单页面时权限控制
      console.log('updateReturnOrderStatus'+operateType)
      if(!this.$isAction(`updateReturnOrderStatus${operateType}`)){
        this.$toast('暂无此操作权限，请联系管理员')
        return false
      }
    }
    let tips
    switch (operateType) {
      case 1:
        tips = '退单审核'
        break;
      case 2:
        tips = '退单收货'
        break;
      case 3:
        tips = '退款审核'
        break;
      case 4:
        tips = '确认收款'
        break;
    }
    let orderIdList = [
      {
        currRouteId: obj.currRouteId,
        returnOrderId: obj.returnOrderId
      }
    ]
    let params = {
      companyId: this.companyId,
      operateType,
      returnOrderIdList: orderIdList
    }

    this.$emit('updateReturnOrderStatus', params, tips)
  }
}
